import { ColumnWidthOutlined } from "@ant-design/icons";
import MasterCrudScreen from "./Mastercrudscreen";
import { MASTERS } from "./Masterapi";
import { TEAL, SKY } from "./Mastertheme";

const config = {
    master: MASTERS.size,
    title: "Size Master",
    singular: "Size",
    plural: "Sizes",
    subtitle: "Manage product sizes",
    icon: <ColumnWidthOutlined />,
    from: TEAL,
    to: SKY,
    fields: [
        { name: "prodSize", label: "Size", placeholder: "e.g. XL", required: true, icon: <ColumnWidthOutlined /> },
    ],
};

export default function SizeMaster() {
    return <MasterCrudScreen config={config} />;
}